import { useEffect, useState } from "react";
import Sections from "./Sections";
import Content from "./Content";
import TooltipBar from "./TooltipBar";
import Breadcrumb from "components/Breadcrumb";
import DataNotFound from "components/DataNotFound";
import { useAppDispatch, useAppSelector } from "app/hooks";
import ConfirmMessage from "components/ConfirmMessage";
import { selectGrades } from "features/filters";
import {
  gradeSet,
  moeViewSet,
  searchBySet,
  searchSet,
  selectGrade,
} from "features/content";
import {
  allClassesSet,
  assignedLessonsSet,
  selectAssignedLessons,
  selectedClassesSet,
} from "features/assignments";
import { useTranslation } from "react-i18next";
import { useFetchClassesQuery } from "services/common";
import { IGrade } from "features/common/Interfaces";
import { handleFetchedClasses } from "utils/HomeHelpers";
import GradesList from "components/GradeList";

function Home() {
  const { t } = useTranslation();
  const dispatch = useAppDispatch();
  const loadedGrades = useAppSelector(selectGrades);
  const [modalOpen, setModalOpen] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const { assignedLosCount } = useAppSelector(selectAssignedLessons);
  const selectedGrade = useAppSelector(selectGrade);
  const [currentGrade, setCurrentGrade] = useState<IGrade>();
  const { data: classesData } = useFetchClassesQuery(
    selectedGrade?.id as number,
    {
      skip: !selectedGrade?.id,
    }
  );

  useEffect(() => {
    if (classesData) {
      const { allClasses, selectedClasses } = handleFetchedClasses(classesData);
      dispatch(allClassesSet(allClasses));
      dispatch(selectedClassesSet(selectedClasses));
    }
  }, [classesData]);

  const changeGradeHandler = (grade: IGrade) => {
    if (assignedLosCount) {
      setModalOpen(true);
      setCurrentGrade(grade);
    } else gradeChangeHandler(grade);
  };

  const deleteHandler = (answer: "yes" | "no") => {
    if (answer === "yes") {
      setModalOpen(false);
      gradeChangeHandler(currentGrade!);
    } else {
      setModalOpen(false);
    }
  };

  const gradeChangeHandler = (grade: IGrade) => {
    dispatch(gradeSet(grade));
    dispatch(moeViewSet(false));
    dispatch(
      assignedLessonsSet({
        losList: [],
        unitList: [],
        assignedLosCount: 0,
      })
    );
    dispatch(searchSet(""));
    dispatch(searchBySet({ label: t("Name"), value: "name" }));
  };

  const sessionExpired = localStorage.getItem("expired");

  return (
    <>
      {loadedGrades?.length === 0 && !isLoading ? (
        <DataNotFound
          text={sessionExpired === "true" ? undefined : "No students exists"}
        />
      ) : (
        <>
          <Breadcrumb />
          <GradesList
            onGradeChange={changeGradeHandler}
            selectedGrade={selectedGrade}
            getIsGradeLoading={setIsLoading}
          />
          <Sections isLoading={isLoading} />
          <Content isLoading={isLoading} />
          <TooltipBar />
          <ConfirmMessage
            open={modalOpen}
            onClose={deleteHandler}
            description={t("Data will be lost on change grade")}
            title={t("Warning")}
          />
        </>
      )}
    </>
  );
}

export default Home;
